// extracted by mini-css-extract-plugin
module.exports = {"themeItem":"ThemeSelectorFooter_themeItem__Vn5pG","selected":"ThemeSelectorFooter_selected__8JRzy","checkbox":"ThemeSelectorFooter_checkbox__kCs3G"};